import { useState } from "react";
import { LANGS, useI18n, type Lang } from "../i18n";

export function LangSwitcher() {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang)!;

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className="pill-outline !py-2 !px-4 text-sm"
      >
        {current.label} ▾
      </button>
      {open && (
        <div
          onMouseLeave={() => setOpen(false)}
          className="absolute right-0 mt-2 bg-[var(--color-cream-light)] border border-[var(--color-sage)]/50 rounded-xl p-1 shadow-lg min-w-[90px] z-50"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code as Lang);
                setOpen(false);
              }}
              className={`block w-full text-left px-3 py-2 rounded-lg text-sm ${
                l.code === lang
                  ? "bg-[var(--color-sage-light)]/70 text-[var(--color-forest-deep)]"
                  : "hover:bg-[var(--color-cream)]"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
